import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import TestimonialsSection from '../components/TestimonialsSection';
import Lightbox from '../components/Lightbox';
import ContactForm from '../components/ContactForm';
import { imageUrl } from '../lib/images';

export default function BrandingPage() {
  const [isPosterLightboxOpen, setIsPosterLightboxOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('Pakke 2: Content Abonnement');

  const branches = [
    {
      title: 'Caféer & Restauranter',
      icon: 'fa-solid fa-mug-saucer',
      image: '/_assets/75513566-168614701331698-9032259809111210225-n.jpg',
    },
    {
      title: 'Butikker & Webshops',
      icon: 'fa-solid fa-shirt',
      image: '/_assets/142299669-247059033487264-5481047819933199986-n.jpg',
    },
    {
      title: 'Fitness & Sundhed',
      icon: 'fa-solid fa-dumbbell',
      image: '/_assets/166783092-283183186541515-3612883362797497453-n.jpg',
    },
    {
      title: 'Klinikker & Behandlere',
      icon: 'fa-solid fa-hand-holding-heart',
      image: '/_assets/142081323-247059026820598-2713212477238493269-n.jpg',
    },
    {
      title: 'Håndværkere & Service',
      icon: 'fa-solid fa-screwdriver-wrench',
      image: '/_assets/487316894-1134600408683405-7489097942827672171-n.jpg',
    },
    {
      title: 'Virksomheder & Kontorer',
      icon: 'fa-solid fa-building',
      image: '/_assets/487214857-1134600378683408-2220849442786892437-n.jpg',
    },
  ];

  const packages = [
    {
      badge: 'PAKKE 1',
      title: 'FOTO + VIDEO SHOOT',
      subtitle: 'En komplet visuel fortælling om jeres virksomhed.',
      price: '7.500 kr.',
      period: 'ekskl. moms',
      popular: false,
      features: [
        '20 professionelt redigerede billeder',
        '1 video på ca. 30 sekunder',
        'Indhold målrettet jeres brand og målgruppe',
        'Perfekt til hjemmeside, sociale medier og markedsføring',
      ],
      contactParam: 'Pakke 1: Foto + Video Shoot',
      icon: 'fa-solid fa-camera',
    },
    {
      badge: 'PAKKE 2',
      title: 'CONTENT ABONNEMENT',
      subtitle: 'Løbende indhold, der holder jeres sociale medier levende.',
      price: '3.500 kr.',
      period: 'ekskl. moms / måned',
      popular: true,
      features: [
        'Månedligt besøg',
        '20 professionelt redigerede billeder hver måned',
        'Indhold tilpasset sæsoner, events og jeres behov',
        'Perfekt til sociale medier og hjemmeside',
      ],
      contactParam: 'Pakke 2: Content Abonnement',
      icon: 'fa-solid fa-mobile-screen-button',
    },
    {
      badge: 'PAKKE 3',
      title: 'CONTENT PLUS',
      subtitle: 'Den komplette løsning til jer, der ønsker endnu mere synlighed.',
      price: '4.500 kr.',
      period: 'ekskl. moms / måned',
      popular: false,
      features: [
        'Månedligt besøg',
        '30 professionelt redigerede billeder hver måned',
        '1 reel/video på op til 15 sekunder hver måned',
        'Indhold tilpasset sæsoner, events og jeres behov',
        'Perfekt til sociale medier, hjemmeside og kampagner',
      ],
      contactParam: 'Pakke 3: Content Plus',
      icon: 'fa-solid fa-laptop-code',
    },
  ];

  const valuesBar = [
    { label: 'AUTENTISK INDHOLD', icon: 'fa-solid fa-camera' },
    { label: 'STYRKER JERES BRAND', icon: 'fa-solid fa-heart' },
    { label: 'FLERE KUNDER OG BOOKINGER', icon: 'fa-solid fa-chart-line' },
    { label: 'SPARER JER TID', icon: 'fa-solid fa-clock' },
    { label: 'TILPASSET JERES BRANCHE', icon: 'fa-solid fa-users' },
    { label: 'FLEKSIBLE LØSNINGER', icon: 'fa-solid fa-calendar-check' },
  ];

  const galleryImages = [
    {
      src: '/_assets/75513566-168614701331698-9032259809111210225-n.jpg',
      alt: 'Stemningsfuld anretning og mad',
    },
    {
      src: '/_assets/142299669-247059033487264-5481047819933199986-n.jpg',
      alt: 'Virksomhed og butiksmiljø',
    },
    {
      src: '/_assets/487316894-1134600408683405-7489097942827672171-n.jpg',
      alt: 'Detaljer og håndværk',
    },
    {
      src: '/_assets/487214857-1134600378683408-2220849442786892437-n.jpg',
      alt: 'Lokation og restaurantstemning',
    },
  ];

  return (
    <>
      <SEO
        title="Branding & Markedsføring – Foto, Video & Content | Lunde Media"
        description="Styrk jeres synlighed med professionelt foto og video. Autentisk og engagerende visuelt indhold til caféer, restauranter, butikker og virksomheder."
      />

      {/* 1. Hero Section (Match af bookninger.png: Varm mørk glød, centreret stemning og håndskrevet badge) */}
      <section className="relative min-h-[85vh] lg:min-h-[90vh] flex flex-col justify-between pt-32 pb-0 overflow-hidden bg-[#111113] text-white">
        {/* Baggrundsbillede med varm restaurant/café glød */}
        <div className="absolute inset-0 z-0 pointer-events-none">
          <img
            src={imageUrl('/_assets/142299669-247059033487264-5481047819933199986-n.jpg', 'width=1920,quality=85,format=auto')}
            alt="Professionelt brand shoot og markedsføring"
            className="w-full h-full object-cover filter brightness-[0.35] contrast-[1.08]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0C0C0D] via-[#0C0C0D]/60 to-black/70" />
        </div>

        {/* Hovedindhold i Hero */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 w-full my-auto py-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Venstre kolonne: Titel, brødtekst og CTA */}
            <div className="lg:col-span-8 space-y-6">
              <div className="inline-flex items-center gap-2.5 px-3.5 py-1.5 bg-[#E87A38]/15 border border-[#E87A38]/40 text-[#E87A38] text-xs uppercase tracking-widest font-semibold">
                <i className="fa-solid fa-bullhorn text-[11px]" aria-hidden="true" />
                <span>Foto · Video · Historier</span>
              </div>

              <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-medium text-[#F4EFEA] tracking-tight leading-[1.1]">
                Styrk jeres synlighed med professionelt{' '}
                <span className="text-[#E87A38]">foto og video</span>
              </h1>

              <p className="text-base sm:text-lg md:text-xl text-stone-300 font-sans max-w-2xl leading-relaxed">
                Autentisk og engagerende visuelt indhold, der viser hvem I er, hvad I laver, og hvorfor kunder skal vælge netop jer.
              </p>

              <div className="pt-2 flex flex-wrap items-center gap-4">
                <a
                  href="#kontakt-sektion"
                  className="cta-btn inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#E87A38] hover:bg-[#d66e2f] text-white font-semibold text-sm uppercase tracking-wider transition-all shadow-xl hover:shadow-2xl"
                >
                  <span>Book et shoot</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </a>

                <a
                  href="#pakker"
                  className="cta-btn inline-flex items-center justify-center px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-medium text-sm uppercase tracking-wider transition-all border border-white/30 backdrop-blur-xs"
                >
                  Se pakker & priser
                </a>
              </div>
            </div>

            {/* Højre kolonne: Håndskrevet rund badge som i bookninger.png */}
            <div className="lg:col-span-4 flex justify-center lg:justify-end">
              <div className="relative group max-w-[280px] sm:max-w-[320px]">
                <div className="w-56 h-56 sm:w-64 sm:h-64 rounded-full bg-[#E87A38] text-white p-6 sm:p-8 flex flex-col items-center justify-center text-center shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-300 border-2 border-white/20">
                  <p className="font-handwriting text-2xl sm:text-3xl leading-snug font-semibold text-stone-50 drop-shadow-sm">
                    Visuelle historier, der skaber resultater på sociale medier og hjemmeside
                  </p>
                  <span className="text-2xl mt-2 text-stone-100">♡</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 4-ikon bjælke under heroen (Direkte tro mod bookninger.png) */}
        <div className="relative z-10 w-full border-t border-white/15 bg-black/85 backdrop-blur-md py-6 sm:py-7">
          <div className="max-w-6xl mx-auto px-6 md:px-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 items-center justify-center">
              <div className="flex items-center justify-center gap-3.5 text-left group">
                <div className="w-10 h-10 rounded-full border border-white/20 bg-white/5 flex items-center justify-center shrink-0">
                  <i className="fa-regular fa-image text-white text-base group-hover:text-[#E87A38] transition-colors" aria-hidden="true" />
                </div>
                <span className="text-[11px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-white font-sans leading-snug">
                  Stemningsfulde<br />billeder
                </span>
              </div>
              <div className="flex items-center justify-center gap-3.5 text-left group">
                <div className="w-10 h-10 rounded-full border border-white/20 bg-white/5 flex items-center justify-center shrink-0">
                  <i className="fa-solid fa-play text-white text-xs pl-0.5 group-hover:text-[#E87A38] transition-colors" aria-hidden="true" />
                </div>
                <span className="text-[11px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-white font-sans leading-snug">
                  Engagerende<br />videoer
                </span>
              </div>
              <div className="flex items-center justify-center gap-3.5 text-left group">
                <div className="w-10 h-10 rounded-full border border-white/20 bg-white/5 flex items-center justify-center shrink-0">
                  <i className="fa-solid fa-user-group text-white text-sm group-hover:text-[#E87A38] transition-colors" aria-hidden="true" />
                </div>
                <span className="text-[11px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-white font-sans leading-snug">
                  Mere synlighed<br />og flere kunder
                </span>
              </div>
              <div className="flex items-center justify-center gap-3.5 text-left group">
                <div className="w-10 h-10 rounded-full border border-white/20 bg-white/5 flex items-center justify-center shrink-0">
                  <i className="fa-solid fa-chart-line text-white text-sm group-hover:text-[#E87A38] transition-colors" aria-hidden="true" />
                </div>
                <span className="text-[11px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-white font-sans leading-snug">
                  Tilpasset jeres<br />branche og mål
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. "HVEM JEG ARBEJDER MED" Sektion (Direkte fra bookninger.png) */}
      <section className="py-14 md:py-20 bg-[#F5EFE6] text-[#141416] border-b border-stone-300">
        <div className="max-w-6xl mx-auto px-6 md:px-8">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-xs sm:text-sm font-semibold uppercase tracking-[0.28em] text-[#141416]">
              Hvem jeg arbejder med
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
            {branches.map((b, i) => (
              <div
                key={i}
                className="group bg-white/80 hover:bg-white border border-stone-200/90 hover:border-[#E87A38]/50 shadow-xs hover:shadow-md transition-all p-4 sm:p-5 flex flex-col items-center justify-center text-center rounded-xs"
              >
                <div className="w-12 h-12 rounded-full bg-[#FAF6F0] group-hover:bg-[#E87A38]/10 border border-stone-200/80 flex items-center justify-center mb-3 transition-colors">
                  <i className={`${b.icon} text-base text-[#E87A38]`} aria-hidden="true" />
                </div>
                <span className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em] text-[#141416] leading-snug">
                  {b.title}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3. Prispakkerne (Pakke 1, Pakke 2, Pakke 3 som i bookninger.png) */}
      <section id="pakker" className="py-20 md:py-28 bg-[#FAF6F0] text-[#141416] border-b border-stone-300">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium text-[#141416] tracking-tight">
              Vælg den rette pakke til jeres synlighed
            </h2>
            <p className="text-stone-600 text-base md:text-lg max-w-2xl mx-auto font-sans">
              Skræddersyede løsninger til både enkeltstående produktioner og fast månedligt indhold.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
            {packages.map((pkg, idx) => (
              <div
                key={idx}
                className={`relative bg-white border flex flex-col justify-between p-8 sm:p-9 transition-all duration-300 shadow-md ${
                  pkg.popular
                    ? 'border-[#E87A38] ring-2 ring-[#E87A38]/30 shadow-xl'
                    : 'border-stone-200 hover:border-stone-400'
                }`}
              >
                {/* Pakke badge i toppen */}
                <div className="mb-6">
                  <div className="inline-block px-4 py-1.5 bg-[#4A3225] text-white text-[11px] font-semibold uppercase tracking-widest mb-3">
                    {pkg.badge}
                  </div>

                  <h3 className="text-2xl sm:text-3xl font-serif font-bold text-[#141416] tracking-wide">
                    {pkg.title}
                  </h3>

                  <p className="text-stone-600 text-xs sm:text-sm mt-2 leading-relaxed min-h-[38px]">
                    {pkg.subtitle}
                  </p>
                </div>

                {/* Tjekliste */}
                <div className="space-y-3.5 my-6 pt-4 border-t border-stone-200">
                  {pkg.features.map((feat, fIdx) => (
                    <div key={fIdx} className="flex items-start gap-3 text-xs sm:text-sm text-stone-700">
                      <span className="w-5 h-5 rounded-full bg-[#E87A38]/15 text-[#E87A38] flex items-center justify-center shrink-0 mt-0.5">
                        <i className="fa-solid fa-check text-[10px]" aria-hidden="true" />
                      </span>
                      <span className="leading-snug">{feat}</span>
                    </div>
                  ))}
                </div>

                {/* Pris & Knap */}
                <div className="pt-6 border-t border-stone-200 space-y-5">
                  <div className="bg-[#4A3225] text-white p-4 text-center rounded-none shadow-inner">
                    <div className="text-3xl sm:text-4xl font-serif font-bold tracking-tight">
                      {pkg.price}
                    </div>
                    <div className="text-xs uppercase tracking-wider text-stone-300 font-sans mt-0.5">
                      {pkg.period}
                    </div>
                  </div>

                  <a
                    href="#kontakt-sektion"
                    onClick={() => setSelectedPackage(pkg.contactParam)}
                    className="cta-btn w-full inline-flex items-center justify-center gap-2 py-3.5 px-6 bg-[#E87A38] hover:bg-[#d66e2f] text-white font-semibold text-xs sm:text-sm uppercase tracking-wider transition-all shadow-md"
                  >
                    <span>Book {pkg.badge.toLowerCase()}</span>
                    <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Infografik-link */}
          <div className="mt-12 text-center">
            <button
              type="button"
              onClick={() => setIsPosterLightboxOpen(true)}
              className="inline-flex items-center gap-2 text-xs sm:text-sm font-medium text-stone-700 hover:text-black underline cursor-pointer"
            >
              <i className="fa-solid fa-magnifying-glass-plus text-[#E87A38]" aria-hidden="true" />
              <span>Se det originale oversigtskort i fuld størrelse</span>
            </button>
          </div>
        </div>
      </section>

      {/* 4. Ikon-værdier bånd (6 fordele med tynde separatorer som i bookninger.png) */}
      <section className="py-12 bg-[#F5EFE6] text-[#141416] border-b border-stone-300">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 text-center divide-y lg:divide-y-0 lg:divide-x divide-stone-300">
            {valuesBar.map((v, i) => (
              <div key={i} className="flex flex-col items-center justify-center gap-2.5 px-3 py-2">
                <div className="w-10 h-10 rounded-full bg-white border border-stone-300 flex items-center justify-center shadow-xs">
                  <i className={`${v.icon} text-base text-[#E87A38]`} aria-hidden="true" />
                </div>
                <span className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-stone-800">
                  {v.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. Dybdegående tekst fra kundens Word-dokument (Dokument (4).docx) */}
      <section className="py-20 md:py-28 bg-white text-[#141416] border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-6 md:px-8 space-y-16 md:space-y-20">
          
          {/* Afsnit 1: Billeder skal ikke bare være flotte. De skal føles rigtige. */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-start">
            <div className="lg:col-span-5 space-y-4">
              <div className="inline-block px-3 py-1 bg-stone-100 text-stone-700 text-xs uppercase tracking-widest font-semibold border-l-2 border-[#E87A38]">
                Filosofi & Tilgang
              </div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium text-[#141416] leading-tight">
                Billeder skal ikke bare være flotte. De skal føles rigtige.
              </h2>
              <p className="text-xl sm:text-2xl font-serif text-[#4A3225] font-semibold italic pt-2">
                Den begynder med dig.
              </p>
            </div>

            <div className="lg:col-span-7 space-y-4 text-stone-700 text-base sm:text-lg leading-relaxed font-sans">
              <p>
                Når du booker <strong className="text-stone-900">Lunde Media</strong>, begynder opgaven ikke med kameraet.
              </p>
              <p>
                Jeg vil gerne forstå, hvem du er, hvad du laver, og vigtigst af alt:{' '}
                <strong className="text-stone-900">
                  Hvad skal mennesker føle, når de ser dine billeder eller din video?
                </strong>
              </p>
              <p>
                For mig handler god fotografering ikke om at gøre virkeligheden perfekt. Det handler om at finde det særlige i den virkelighed, der allerede er der – og fange det på en måde, der føles ægte.
              </p>
            </div>
          </div>

          <div className="w-full h-px bg-stone-200" />

          {/* Afsnit 2 & 3: To kolonner med nysgerrighed og autenticitet */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
            {/* Mindre opstillet. Mere autentisk. */}
            <div className="space-y-4 p-8 sm:p-10 bg-[#FAF8F5] border border-stone-200 flex flex-col justify-between shadow-xs">
              <div className="space-y-4">
                <div className="w-11 h-11 rounded-full bg-[#E87A38]/10 text-[#E87A38] flex items-center justify-center">
                  <i className="fa-solid fa-camera text-base" aria-hidden="true" />
                </div>
                <h3 className="text-2xl sm:text-3xl font-serif font-bold text-[#141416]">
                  Mindre opstillet. Mere autentisk.
                </h3>
                <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
                  Jeg tror på billeder med personlighed.
                </p>
                <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
                  De små øjeblikke. Et blik. Et grin. Hænderne, der arbejder. Stemningen i rummet. Det, der sker mellem de billeder, man normalt ville stille op til.
                </p>
                <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
                  Selvfølgelig hjælper jeg med placering, lys og retning, når der er brug for det. Men mit mål er ikke, at du bagefter skal kigge på billederne og tænke: <em>“Det ser professionelt ud.”</em>
                </p>
              </div>
              <p className="text-stone-900 font-semibold text-base sm:text-lg pt-4 border-t border-stone-200">
                Jeg vil hellere have, at du tænker: “Det dér er os.”
              </p>
            </div>

            {/* Når du booker mig, får du også min nysgerrighed */}
            <div className="space-y-4 p-8 sm:p-10 bg-[#FAF8F5] border border-stone-200 flex flex-col justify-between shadow-xs">
              <div className="space-y-4">
                <div className="w-11 h-11 rounded-full bg-[#E87A38]/10 text-[#E87A38] flex items-center justify-center">
                  <i className="fa-solid fa-lightbulb text-base" aria-hidden="true" />
                </div>
                <h3 className="text-2xl sm:text-3xl font-serif font-bold text-[#141416]">
                  Når du booker mig, får du også min nysgerrighed
                </h3>
                <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
                  Jeg kommer ikke med den samme opskrift til alle kunder.
                </p>
                <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
                  En café skal ikke fortælle den samme historie som en håndværker. En virksomhed skal ikke ligne alle sine konkurrenter. Og et menneske foran mit kamera skal ikke presses ind i et bestemt udtryk, bare fordi det ser godt ud på Instagram.
                </p>
                <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
                  Derfor bruger jeg tid på at finde ud af,{' '}
                  <strong className="text-stone-900">hvad der gør netop dig eller din virksomhed værd at huske.</strong>
                </p>
              </div>
              <p className="text-stone-700 text-sm sm:text-base leading-relaxed pt-4 border-t border-stone-200">
                Før et shoot taler vi om jeres ønsker, målgruppe, visuelle stil og hvad materialet konkret skal bruges til. Derefter bygger vi fotograferingen omkring det.
              </p>
            </div>
          </div>

          {/* Afsnit 4: Du behøver ikke være god foran et kamera */}
          <div className="bg-[#141416] text-white p-8 sm:p-12 lg:p-14 border border-stone-800 shadow-xl">
            <div className="max-w-4xl space-y-5">
              <span className="text-xs uppercase tracking-widest font-semibold text-[#E87A38]">
                Tryghed under shootet
              </span>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-medium text-[#F4EFEA]">
                Du behøver ikke være god foran et kamera
              </h3>
              <p className="text-stone-300 text-base sm:text-lg leading-relaxed">
                Faktisk foretrækker jeg næsten, at du glemmer, det er der.
              </p>
              <p className="text-stone-300 text-sm sm:text-base leading-relaxed">
                Du behøver ikke vide, hvordan du skal stå, hvor du skal kigge eller hvad du skal gøre med hænderne. Det er mit ansvar at skabe en situation, hvor du kan være naturlig – og samtidig sørge for, at lys, komposition og øjeblik sidder rigtigt.
              </p>
              <p className="text-stone-300 text-sm sm:text-base leading-relaxed">
                Det samme gælder, når jeg fotograferer en virksomhed.
              </p>
              <div className="pt-2">
                <p className="text-[#E87A38] font-semibold text-base sm:text-lg">
                  Jeg vil hellere fange mennesker midt i det, de er gode til, end bede dem om at spille en rolle foran kameraet.
                </p>
              </div>
            </div>
          </div>

          {/* Afsnit 5: Det kan du forvente af Lunde Media */}
          <div className="space-y-8">
            <div>
              <span className="text-xs uppercase tracking-widest font-semibold text-[#E87A38]">
                Gennemsigtighed & kvalitet
              </span>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-[#141416] mt-1">
                Det kan du forvente af Lunde Media
              </h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { title: 'Personlig dialog', desc: 'En personlig dialog før fotograferingen', icon: 'fa-solid fa-comments' },
                { title: 'Fælles mål', desc: 'Et klart fælles mål for materialet', icon: 'fa-solid fa-bullseye' },
                { title: 'Tryg stemning', desc: 'Rolig og uformel stemning under shootet', icon: 'fa-solid fa-mug-hot' },
                { title: 'Høj kvalitet', desc: 'Professionel fotografering og efterbehandling', icon: 'fa-solid fa-award' },
                { title: 'Autenticitet', desc: 'Fokus på autentiske mennesker og situationer', icon: 'fa-solid fa-heart' },
                { title: 'Brugbarhed', desc: 'Billeder og video skabt til det sted, de faktisk skal bruges', icon: 'fa-solid fa-share-nodes' },
              ].map((item, i) => (
                <div key={i} className="p-6 bg-[#FAF8F5] border border-stone-200 flex items-start gap-4 shadow-xs">
                  <span className="w-10 h-10 rounded-full bg-[#E87A38]/15 text-[#E87A38] flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-sm`} aria-hidden="true" />
                  </span>
                  <div>
                    <h4 className="text-base font-semibold text-stone-900">{item.title}</h4>
                    <p className="text-xs sm:text-sm text-stone-600 mt-1 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Afsnit 6: Professionelt må gerne være personligt */}
          <div className="p-8 sm:p-12 border-2 border-stone-200 bg-[#FAF8F5] space-y-4">
            <span className="text-xs uppercase tracking-widest font-semibold text-[#E87A38]">
              Mennesket i centrum
            </span>
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-[#141416]">
              Professionelt må gerne være personligt
            </h3>
            <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
              I en tid, hvor vi bliver mødt af enorme mængder indhold – og hvor kunstige billeder kan skabes på få sekunder – tror jeg, at det menneskelige bliver endnu vigtigere.
            </p>
            <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
              Man skal kunne mærke menneskene bag en virksomhed. Det er derfor, jeg ikke forsøger at gøre jer til noget, I ikke er.
            </p>
            <p className="text-[#4A3225] font-serif font-bold text-xl sm:text-2xl italic pt-2">
              »Jeg vil gøre det, I allerede er, værd at lægge mærke til.«
            </p>
          </div>
        </div>
      </section>

      {/* 6. Billedgalleri (4 stemningsbilleder som i bunden af bookninger.png) */}
      <section className="py-12 bg-[#F5EFE6] border-b border-stone-300">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {galleryImages.map((img, i) => (
              <div key={i} className="aspect-square overflow-hidden bg-stone-200 shadow-sm border border-stone-300">
                <img
                  src={imageUrl(img.src, 'width=600,quality=80,format=auto')}
                  alt={img.alt}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 8. Direkte Kontakt & Bookingformular (Optimeret til outreach leads) */}
      <section id="kontakt-sektion" className="py-20 md:py-28 bg-[#111113] text-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Venstre side: Michael Lundes direkte kontaktinformation som i bookninger.png */}
            <div className="lg:col-span-5 space-y-8">
              <div>
                <p className="font-handwriting text-3xl sm:text-4xl text-[#E87A38] leading-tight">
                  Skal vi skabe jeres næste historie?
                </p>
                <div className="w-16 h-[2px] bg-[#E87A38] mt-3" />
              </div>

              <div className="space-y-4 text-stone-300 text-sm sm:text-base leading-relaxed">
                <p>
                  Uanset om du driver en café, butik, klinik, håndværksvirksomhed eller noget helt andet, hjælper jeg jer med visuelt indhold, der skaber opmærksomhed, tillid og nye kunder.
                </p>
                <p>
                  Uanset om du mangler nye billeder til hjemmesiden, løbende content til sociale medier, portrætter, branding eller professionel video, starter vi samme sted:
                </p>
                <p className="text-white font-serif font-bold text-lg sm:text-xl text-[#F4EFEA]">
                  Hvad vil du gerne have mennesker til at se, mærke – og huske?
                </p>
                <p>
                  Så finder vi sammen ud af, hvordan vi fortæller det.
                </p>
              </div>

              {/* Kontaktboks */}
              <div className="p-6 bg-white/5 border border-white/10 space-y-4 backdrop-blur-xs">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#E87A38]/20 text-[#E87A38] flex items-center justify-center shrink-0">
                    <i className="fa-solid fa-phone text-sm" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-[11px] uppercase tracking-wider text-stone-400">Telefon</div>
                    <a href="tel:26368306" className="text-white font-medium hover:text-[#E87A38] transition-colors">
                      26 36 83 06
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#E87A38]/20 text-[#E87A38] flex items-center justify-center shrink-0">
                    <i className="fa-solid fa-envelope text-sm" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-[11px] uppercase tracking-wider text-stone-400">E-mail</div>
                    <a href="mailto:kontakt@lundemedia.dk" className="text-white font-medium hover:text-[#E87A38] transition-colors">
                      kontakt@lundemedia.dk
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#E87A38]/20 text-[#E87A38] flex items-center justify-center shrink-0">
                    <i className="fa-solid fa-globe text-sm" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-[11px] uppercase tracking-wider text-stone-400">Hjemmeside</div>
                    <span className="text-white font-medium">www.lundemedia.dk</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Højre side: Hurtig henvendelsesformular */}
            <div className="lg:col-span-7 bg-white text-stone-900 p-8 sm:p-10 border border-stone-200 shadow-2xl">
              <div className="mb-6 space-y-1">
                <span className="text-xs uppercase tracking-widest font-semibold text-[#E87A38]">
                  Hurtig henvendelse
                </span>
                <h3 className="text-2xl sm:text-3xl font-serif font-bold text-stone-950">
                  Tag en uforpligtende snak om jeres branding
                </h3>
                <p className="text-xs sm:text-sm text-stone-600">
                  Udfyld formularen, så vender Michael tilbage inden for 24 timer.
                </p>
              </div>

              <ContactForm
                defaultSubject={selectedPackage}
                subjectOptions={[
                  'Pakke 1: Foto + Video Shoot',
                  'Pakke 2: Content Abonnement',
                  'Pakke 3: Content Plus',
                  'Uforpligtende snak om branding',
                  'Andet / Skræddersyet forespørgsel',
                ]}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox for bookingplakat / original mockup */}
      {isPosterLightboxOpen && (
        <Lightbox
          images={['/_assets/bookninger.png']}
          currentIndex={0}
          isOpen={isPosterLightboxOpen}
          onClose={() => setIsPosterLightboxOpen(false)}
        />
      )}
    </>
  );
}
